import React from 'react';
import Tooltip from 'core/ui-kit/tooltip';
import useDevice from "core/hooks/useDevice";

const Ellipsis = ({
    value,
    maxWidth = 260,
    mobileMaxWidth = 120,
    emptySymbol = '-',
}) => {

    const { isMobile } = useDevice();
    const maxWidthValue = isMobile ? mobileMaxWidth : maxWidth;

    const valueRenderer = () => (
        <div
            className="rt--ellipsis"
            style={{maxWidth: maxWidthValue}}
        >
            {value || emptySymbol}
        </div>
    );

    return (
        <div className='rt--table-col rt--flex rt--align-center'>
            {
                value ? (
                    <Tooltip 
                        placement='top' 
                        title={value} 
                        trigger={["hover"]} 
                        enableMobile
                    >
                        {valueRenderer()}
                    </Tooltip>
                ) : (
                    <>
                        {valueRenderer()}
                    </>
                )
            }
        </div>
    );
}

export default Ellipsis;